// App.jsx
import React from "react";
import RoutesApp from "./routes.jsx";


export default function App() {

  return <RoutesApp />;
}
